import { useNavigate } from "react-router-dom";

import UserTopbar from "../../features/manageUsers/topbar";
import UserList from "../../features/manageUsers/userList";
import { useState } from "react";

const ManageUser = () => {
  const navigate = useNavigate();
  const [debouceSearchTerm, setDebouceSearchTerm] = useState<string>("");
  const [page, setPage] = useState<number>(1);

  return (
    <>
      <div className="main_title">
        <h1>Manage Users</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Manage Users
        </p>
      </div>
      <div className="cards">
        <UserTopbar page={page} debouceSearchTerm={debouceSearchTerm} setDebouceSearchTerm={setDebouceSearchTerm} />
        <UserList search={debouceSearchTerm} page={page} setPage={setPage} />
      </div>
    </>
  );
};

export default ManageUser;
